var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShieldCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 27.4853V12.8186C10 12.2882 10.2107 11.7795 10.5858 11.4044C10.9609 11.0293 11.4696 10.8186 12 10.8186H52C52.5304 10.8186 53.0391 11.0293 53.4142 11.4044C53.7893 11.7795 54 12.2882 54 12.8186V27.4853C54 48.4891 36.1735 55.4478 32.6141 56.6279C32.2161 56.7649 31.7839 56.7649 31.386 56.6279C27.8265 55.4478 10 48.4891 10 27.4853Z",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43 24.8186L28.3333 38.8186L21 31.8186",
    stroke: "#677791",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/ShieldCheck.86fb30ba7ccca3a8fa93bfc8fb5ba921.svg";
export { ForwardRef as ReactComponent };